export default __webpack_public_path__ + "static/media/184.b50bdbc6.png";